// extracted by mini-css-extract-plugin
var _1 = "ayAb11xHkxJCxXwjW3KY";
export { _1 as "container" }
